/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const getNotification = stores => stores.notificationViewStore.notifications;
export const getNotificationBanner = stores => stores.notificationViewStore.notificationBanners;
export const getNotificationBannerHeight = stores => id =>
  stores.notificationViewStore.notificationBanners.reduce(
    (acc, val) => (val.id < id ? acc + (val.height || 0) : acc),
    0
  );
export const getNotificationHeight = stores => id =>
  stores.notificationViewStore.notifications.reduce((acc, val) => (val.id <= id ? acc + (val.height || 0) : acc), 0);

export const getCurrentNotificationBannerHeight = stores =>
  stores.notificationViewStore.currentNotificationBannerHeight;

export const getShouldRenderBannerBeforeDoc = stores => stores.notificationViewStore.renderBannerBeforeDoc;
